import React from "react"
import { Divider, Stack, Typography } from "@mui/material"
import { FaIcon } from "../../../../../mp-core/icons"
import { IconButton } from "../../"
import { StylesType } from "../styles"

interface Props {
  totalPages: number
  currentPage: number
  classes: StylesType
  onChangePage: (nextPage: number) => void
}

const GhostiePagination: React.FC<Props> = ({
  totalPages,
  currentPage,
  classes,
  onChangePage
}) => {
  return (
    <>
      {totalPages > 1 && (
        <>
          <Divider className={classes.divider} component="hr" />

          <Stack
            spacing={2}
            direction="row"
            className={classes.paginationContainer}
          >
            <IconButton
              size="xsmall"
              onClick={() => {
                if (currentPage <= 1) return
                onChangePage(currentPage - 1)
              }}
            >
              <FaIcon name="angle-left" />
            </IconButton>

            <Typography variant="h6">
              {currentPage} of {totalPages}
            </Typography>
            <IconButton
              size="xsmall"
              onClick={() => {
                if (currentPage >= totalPages) return
                onChangePage(currentPage + 1)
              }}
            >
              <FaIcon name="angle-right" />
            </IconButton>
          </Stack>
        </>
      )}
    </>
  )
}

export default GhostiePagination
